import TheGrid from '@/views/sales/selloutnew/grid'

export default {
  path: '/sales/selloutnew',
  redirect: '/sales/selloutnew/index',
  name: 'Sellout',
  meta: {
    auth: {
      redirect: {
        name: 'selloutnew.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Sellout'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'selloutnew.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER','UFS'],
      forbiddenRedirect: '/dashboard',
      label: 'Vendas'
    }
  }]
}
